import React from "react";
import Masonry from "react-masonry-css"; // ★ 追加
import { CheckCircle, Heart } from "lucide-react";
import { ImageData } from "../../../types/gallery";
import LazyImage from "./LazyImage";
import "./ImageGrid.css";

// 拡張されたImageData型
interface ExtendedImageData extends ImageData {
  imageUrl?: string;
}

type Props = {
  images: ImageData[];
  onToggle: (id: number) => void;
  useMasonry?: boolean;
};

// ★ ブレークポイントごとの列数
const breakpoints = {
  default: 6,
  1600: 5,
  1280: 4,
  960: 3,
  640: 2,
};

const ImageGrid = ({ images, onToggle, useMasonry = false }: Props) => {
  if (images.length === 0) {
    return (
      <div className="elegant-empty-grid">
        <Heart size={48} className="empty-heart-icon" />
        <h3 className="empty-title">写真がありません</h3>
        <p className="empty-description">表示する写真がまだアップロードされていません。</p>
      </div>
    );
  }

  // ★ Masonry利用時は Masonry コンポーネントでラップする
  if (useMasonry) {
    return (
      <Masonry
        breakpointCols={breakpoints}
        className="masonry-grid"
        columnClassName="masonry-grid_column"
      >
        {images.map((img) => {
          const statusClass =
            img.isModerated === 1
              ? "approved"
              : img.isModerated === 2
                ? "rejected"
                : "unmoderated";

          return (
            <div
              key={img.id}
              className={`elegant-image-item ${statusClass} ${img.selected ? "selected" : ""}`}
              onClick={() => onToggle(img.id)}
            >
              {/* 画像コンテナ */}
              <div className="image-container">
                <LazyImage
                  src={(img as any).imageUrl || `data:image/png;base64,${img.base64}`}
                  alt={`Wedding Photo ${img.id}`}
                  className="elegant-image"
                  placeholder="🖼️"
                />

                {/* オーバーレイ効果 */}
                <div className="image-overlay">
                  <div className="overlay-content">
                    {img.selected && (
                      <div className="selection-indicator">
                        <CheckCircle size={20} className="check-icon" />
                        <span className="selection-text">選択中</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* ステータスバッジ */}
                <div className="status-badge">
                  {img.isModerated === 1 && (
                    <span className="badge approved-badge">承認済み</span>
                  )}
                  {img.isModerated === 2 && (
                    <span className="badge rejected-badge">拒否済み</span>
                  )}
                  {img.isModerated === 0 && (
                    <span className="badge unmoderated-badge">未検閲</span>
                  )}
                </div>
              </div>

              {/* 装飾的な境界線 */}
              <div className="decorative-border"></div>
            </div>
          );
        })}
      </Masonry>
    );
  }

  // 従来の rows レイアウト
  return (
    <div className="elegant-image-grid">
      {images.map((img) => {
        const statusClass =
          img.isModerated === 1 ? "approved" :
            img.isModerated === 2 ? "rejected" :
              "unmoderated";

        return (
          <div
            key={img.id}
            className={`elegant-image-item ${statusClass} ${img.selected ? "selected" : ""}`}
            onClick={() => onToggle(img.id)}
          >
            <div className="image-container">
              <LazyImage
                src={(img as any).imageUrl || `data:image/png;base64,${img.base64}`}
                alt={`Wedding Photo ${img.id}`}
                className="elegant-image"
                placeholder="🖼️"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageGrid;
